import script from "./TransmissionsCreateShipment.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransmissionsCreateShipment.vue?vue&type=script&setup=true&lang=ts"

import "./TransmissionsCreateShipment.vue?vue&type=style&index=0&id=f90e827e&lang=scss"

const __exports__ = script;

export default __exports__